import { NctsCountry, tardekConfig } from '../../../../config'
import { NctsPhase } from '../../../../shared/ncts/types'
import { useDeclarationEditorContext } from '../contexts/DeclarationEditorContext'

type UseNctsPhaseResult = {
  phase: NctsPhase
  isOptIn: boolean
}

function useNctsPhase(): UseNctsPhaseResult {
  const { editorData } = useDeclarationEditorContext()
  const country = editorData?.country ?? '' as NctsCountry
  const isPhase6OptIn = tardekConfig.phase6OptInCountries.includes(country)
  const isPhase6OptOut = tardekConfig.phase6OptOutCountries.includes(country)
  return {
    phase: isPhase6OptIn || isPhase6OptOut ? 'p6' : 'p5',
    isOptIn: isPhase6OptIn,
  }
}

export default useNctsPhase
